<template>
  <div v-if="hits.length" class="mb-1">
    <p class="px-2 py-1 text-[10px] font-semibold uppercase tracking-wide text-slate-400">{{ label }}</p>
    <button
      v-for="h in hits"
      :key="h.id"
      type="button"
      class="flex w-full flex-col items-start rounded-md px-2 py-1.5 text-left text-sm hover:bg-slate-50 dark:hover:bg-alt-dark-raised"
      @click="$emit('go', h)"
    >
      <span class="flex w-full min-w-0 items-center gap-1.5">
        <span class="truncate text-space-indigo dark:text-altoneo-50">{{ h.name }}</span>
        <!--
          LA MISSION SE SIGNALE DANS LA RECHERCHE (A.8). Deux résultats de même
          nom ne se distinguent pas autrement, et ouvrir du travail vendu en
          croyant ouvrir un projet interne n'est pas une méprise anodine.

          L'ambre n'est pas ici un avertissement : c'est la couleur des missions
          au plan de charge, et c'est elle qu'on cherche d'un écran à l'autre.
        -->
        <AltBadge v-if="h.mission" variant="warning" size="sm" class="shrink-0">Mission</AltBadge>
      </span>
      <span v-if="h.context" class="truncate text-[11px] text-slate-400">{{ h.context }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { SearchHit } from '@its/shared';

defineProps<{ label: string; hits: SearchHit[] }>();
defineEmits<{ go: [SearchHit] }>();
</script>
